<div class="flex justify-end">
  <app-close-chip (closed)="close()" />
</div>
<h2 mat-dialog-title class="text-center">
  {{ 'components.balance_recharge_selection.title' | translate }}
</h2>

<mat-dialog-content class="!p-6 !pt-2">
  <div class="flex flex-col ">
    <div *ngFor="let method of availableMethods"
      class="bg-card-background flex justify-between items-center min-h-24 my-2 p-3 gap-5 rounded-lg border border-solid border-default-dark hover:bg-border-gray hover:cursor-pointer"
      (click)="onSelectMethod(method)"
      >
      <div class="flex items-center content-center">
        <img width="60px" src="assets/img/{{method}}.png">
      </div>
      <div class="flex flex-col justify-evenly">
        <span class="text-default-gray font-medium text-xl text-right m-0">{{ getMethodName(method) | translate }}</span>
      </div>
    </div>
  </div>

  <div *ngIf="availableMethods.length === 0" class="text-center text-default-gray py-4">
    {{ 'components.balance_recharge_selection.no_methods_available' | translate }}
  </div>
</mat-dialog-content>
